import { jsx as _jsx } from "react/jsx-runtime";
import Radio from '../radio/Radio';
import { CheckboxType } from './Checkbox';
import CheckboxButton from './checkboxButton';
const RoundedCheckbox = ({ checkboxType = CheckboxType.SECONDARY, isSelected = false, title, onClick, optionSize, icon, disabled, className, description, value, }) => {
    return (_jsx(Radio, { checked: isSelected, icon: icon, optionSize: optionSize, radioIcon: _jsx(CheckboxButton, { checkboxType: checkboxType, checked: isSelected }), title: title, onClick: onClick, disabled: disabled, className: className, description: description, testId: `option-${value}` }));
};
export default RoundedCheckbox;
//# sourceMappingURL=RoundedCheckbox.js.map